import { render, staticRenderFns } from "./SearchInternetCafes.vue?vue&type=template&id=8863e118&"
import script from "./SearchInternetCafes.vue?vue&type=script&lang=js&"
export * from "./SearchInternetCafes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports